import { render } from "./addcommunity.vue?vue&type=template&id=0cfde89c&scoped=true"
import script from "./addcommunity.vue?vue&type=script&lang=js"
export * from "./addcommunity.vue?vue&type=script&lang=js"

import "./addcommunity.vue?vue&type=style&index=0&id=0cfde89c&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfde89c"]])

export default __exports__